import type { LampWireframeThirdPartyEntry } from '../types/lampWireframes';

function revokeBlobUrl(url?: string | null): void {
  if (!url || !url.startsWith('blob:')) return;
  try {
    URL.revokeObjectURL(url);
  } catch {
    /* ignore revoke errors */
  }
}

export function revokeThirdPartyWireframeUrls(wireframes: LampWireframeThirdPartyEntry[] | null | undefined): void {
  if (!wireframes?.length) return;
  for (const f of wireframes) {
    revokeBlobUrl(f.url);
  }
}

/** Remove third-party wireframe entries for the given lamp uuids and revoke their blob URLs. */
export function removeThirdPartyWireframesForLamps(
  wireframes: LampWireframeThirdPartyEntry[] | null,
  lampUuids: Iterable<string>,
): LampWireframeThirdPartyEntry[] | null {
  if (!wireframes?.length) return wireframes;
  const uuids = lampUuids instanceof Set ? lampUuids : new Set(lampUuids);
  if (uuids.size === 0) return wireframes;

  const toRemove = wireframes.filter((e) => uuids.has(e.lampUuid));
  revokeThirdPartyWireframeUrls(toRemove);

  const remaining = wireframes.filter((e) => !uuids.has(e.lampUuid));
  return remaining.length > 0 ? remaining : null;
}

export function removeThirdPartyWireframeForLamp(
  wireframes: LampWireframeThirdPartyEntry[] | null,
  lampUuid: string,
): LampWireframeThirdPartyEntry[] | null {
  return removeThirdPartyWireframesForLamps(wireframes, [lampUuid]);
}
